import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const CopyIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
    className={makeClassName('CopyIcon', className)}
  >
    <path
      d="M20,23h-9c-1.7,0-3-1.3-3-3v-9c0-1.7,1.3-3,3-3h9c1.7,0,3,1.3,3,3v9C23,21.7,21.7,23,20,23z M11,10c-0.6,0-1,0.4-1,1v9
	c0,0.6,0.4,1,1,1h9c0.6,0,1-0.4,1-1v-9c0-0.6-0.4-1-1-1H11z"
    />
    <path
      d="M5,16H4c-1.7,0-3-1.3-3-3V4c0-1.7,1.3-3,3-3h9c1.7,0,3,1.3,3,3v1c0,0.6-0.4,1-1,1s-1-0.4-1-1V4c0-0.6-0.4-1-1-1H4
	C3.4,3,3,3.4,3,4v9c0,0.6,0.4,1,1,1h1c0.6,0,1,0.4,1,1S5.6,16,5,16z"
    />
  </svg>
);

export default CopyIcon;
